// import { useEffect, useState } from "react";
// import { socket } from "../socket";

// const useCheckoutVisitors = () => {
//   const [visitorCount, setVisitorCount] = useState(0);

//   useEffect(() => {
//     socket.emit("checkout:entered"); // Notify server when user enters

//     socket.on("checkout:visitorCount", (count) => {
//       setVisitorCount(count);
//     });

//     return () => {
//       socket.emit("checkout:left"); // Notify server when user leaves
//       socket.off("checkout:visitorCount");
//     };
//   }, []);

//   return visitorCount;
// };

// export default useCheckoutVisitors;


import { useEffect, useState } from "react";

import { useEffect, useState } from "react";

const useCheckoutVisitors = () => {
  const [visitorCount, setVisitorCount] = useState(() => generateInitialCount());

  useEffect(() => {
    let interval: NodeJS.Timeout;
    let retryDelay = getRandomDelay(3000, 8000); // Start met random interval tussen 3 en 8 sec

    const simulateVisitors = () => {
      interval = setTimeout(() => {
        setVisitorCount((prev) => {
          const change = getRandomChange(prev);
          let newCount = prev + change;

          return Math.max(getMinVisitors(), Math.min(getMaxVisitors(), newCount));
        });

        retryDelay = exponentialBackoff(retryDelay);
        simulateVisitors();
      }, retryDelay);
    };

    simulateVisitors();

    return () => clearTimeout(interval);
  }, []);

  return visitorCount;
};

export default useCheckoutVisitors;

// 🕒 **Simuleer piekmomenten op basis van tijdstip**
function getMinVisitors() {
  const hour = new Date().getHours();
  if (hour >= 6 && hour < 10) return 5;  // Ochtend
  if (hour >= 10 && hour < 17) return 10; // Middag
  if (hour >= 17 && hour < 23) return 20; // Avond (piek)
  return 2; // Late nacht
}

function getMaxVisitors() {
  const hour = new Date().getHours();
  if (hour >= 6 && hour < 10) return 15; // Ochtend
  if (hour >= 10 && hour < 17) return 30; // Middag
  if (hour >= 17 && hour < 23) return 50; // Avond (piek)
  return 10; // Late nacht
}

// 🎭 **Simuleer realistische bezoekersveranderingen**
function getRandomChange(current: number) {
  const baseChange = Math.random() > 0.5 ? 1 : -1;
  const extraVariation = Math.random() > 0.7 ? Math.floor(Math.random() * 5) : 0;
  return baseChange * (1 + extraVariation);
}

// 🔄 **Exponential backoff voor updates**
function exponentialBackoff(currentDelay: number) {
  return Math.min(
    Math.max(currentDelay * (Math.random() * 1.5 + 0.5), 3000), // Min 3s
    15000 // Max 15s
  );
}

// 🎲 **Bepaal een random interval tussen X en Y**
function getRandomDelay(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

// 📊 **Bepaal een startwaarde met piekmomenten**
function generateInitialCount() {
  return Math.floor(Math.random() * (getMaxVisitors() - getMinVisitors())) + getMinVisitors();
}
